import React from 'react';
import styled from 'styled-components';

interface ImageSlidesInterface {
  images: string[]
}

const ImageSlides = ({
  images
}: ImageSlidesInterface) => {
  return (
    <Container>
      <Content
      >
        <img 
          src={images[0]}
        />
      </Content>
    </Container>
  )
}

const Container = styled.div`
  
`;

const Content = styled.div`
  height: auto;
  
  img {
    width: 100%;
    height: inherit;
    object-fit: cover;
  }
`;

export default ImageSlides;